import React from 'react';
import { useStats } from 'react-instantsearch';

const ResultCount = (props) => {
    // eslint-disable-next-line no-unused-vars
    const {hitsPerPage, nbHits, areHitsSorted, nbSortedHits, nbPages, page, processingTimeMS, query} = useStats();

    // let text = props.text.replace('{page}', page + 1).replace('{pages}', nbPages).replace('{total}', nbHits.toLocaleString());

    let text = props.text.replace('{total}', nbHits.toLocaleString());

    if (nbHits) {

        return (
            <div>
                <span className="text-sm text-grey-400 leading-5">
                    {text}
                </span>
            </div>
        );

    } else {
        return '';
    }
}

export { ResultCount }
